export var MetadataTableType;
(function (MetadataTableType) {
  MetadataTableType["VIEW"] = "VIEW";
  MetadataTableType["MATERIALIZED_VIEW"] = "MATERIALIZED_VIEW";
  MetadataTableType["GENERATED_COLUMN"] = "GENERATED_COLUMN";
})(MetadataTableType || (MetadataTableType = {}));